function initializeFadeInObserver(root = document) {
  const images = root.querySelectorAll(".fade-in");

  if (!images.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  images.forEach((img) => observer.observe(img));
}

document.addEventListener('DOMContentLoaded', () => {
  initializeFadeInObserver(document);
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeFadeInObserver(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initializeFadeInObserver(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    initializeFadeInObserver(event.target);
  });
}